import { Switch, Typography } from '@material-tailwind/react';
import { setNotificationSettingsInLocalStorage } from '../lib/local-storage';
import useNotifications from '../store/notifications';

const NotificationSettings = () => {
	const browserDoesNotSupportNotifications = !('Notification' in window);
	const notificationPermission = Notification.permission;
	const browserNotificationsHaveNotBeenEnabled = notificationPermission !== 'granted';
	const { settings, setSettings } = useNotifications();

	const notificationChange = (e, key) => {
		const newSettings = {
			...settings,
			[key]: {
                ...settings[key],
                enabled: e.target.checked
            },
		};
		setNotificationSettingsInLocalStorage(newSettings);
		setSettings(newSettings);
	};

	return (
		<div className="mx-8 mb-4">
			<div className="p-4 pb-2 flex gap-x-10 items-center border-b-4">
				<Typography variant="h5">Notification Settings</Typography>
				{browserDoesNotSupportNotifications && (
					<div className="font-sm italic px-4 py-1 rounded-lg bg-gray-200">
						Your browser does not support desktop notifications. Please reopen using another browser.
					</div>
				)}
				{!browserDoesNotSupportNotifications && browserNotificationsHaveNotBeenEnabled && (
					<div className="font-sm italic px-4 py-1 rounded-lg bg-gray-200">
						You must enable notification permissions in your browser and reload this page.
					</div>
				)}
				{!browserDoesNotSupportNotifications &&
					!browserNotificationsHaveNotBeenEnabled &&
					Object.keys(settings).map((key) => {
						return (
							<div className="flex gap-x-2 items-center">
								{settings[key].label}
								<Switch
									crossOrigin=""
									defaultChecked={settings[key].enabled}
									onChange={(e) => notificationChange(e, key)}
								/>
							</div>
						);
					})}
			</div>
		</div>
	);
};

export default NotificationSettings;
